import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import Input from '../form/input';

import util from '../../lib/util';
import style from './style.css';

const initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false,
    },
};

@observer
class MaillogList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
        this.updateTimer = {};

        const { maillogStore } = this.props.stores;
        maillogStore.list();
    }

    handleScroll = () => {
        const { loading } = this.state;
        const { maillogStore } = this.props.stores;
        const { totalAppend, limit } = maillogStore;
        if (window.innerHeight + document.documentElement.scrollTop + 500
            < document.documentElement.offsetHeight) return;
        if (loading) return;

        let offset = maillogStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(this.scrollLoader);
            this.scrollLoader = setTimeout(async () => {
                this.setState({ loading: true });
                maillogStore.updateOffset(offset);
                await maillogStore.list(true);
                this.setState({ loading: false });
            }, 500);
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    async updateField(id, field, value) {
        const { maillogStore } = this.props.stores;
        maillogStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { maillogStore } = this.props.stores;
        await maillogStore.saveField(id, field, value);
    }

    render() {
        const { loading } = this.state;
        const { maillogStore } = this.props.stores;
        const { maillogs, queryFilter, saved } = maillogStore;

        return (
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-12'>
                        <small class='text-muted font-weight-lighter float-right mr-2'>
                            Total: {maillogStore.total}<br />
                        </small>

                        <span class='float-left form-row align-items-center mr-5'>
                            <div class='col-auto'>
                                <input type='text' class='form-control form-control-sm' id='inlineFormInputName' placeholder='Search for mail logs...'
                                    onInput={e => maillogStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true })}
                                    value={queryFilter.search}
                                />
                            </div>
                            <div class='col-auto'>
                                <button type='button' class='btn btn-sm btn-primary' onClick={() => maillogStore.list()}>Search</button>
                            </div>
                        </span>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-12'>

                        {queryFilter.search && <div class='w-100 text-left mt-2 mb-5'>
                            <h1><i class='fas fa-search' /> Search results</h1>
                            Found {maillogStore.total || 0} results in your search for "{queryFilter.search}".<br />
                            <button class='btn btn-sm btn-warning mt-2'
                                onClick={() => maillogStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true })}
                            >
                                <i class='fas fa-times' /> Reset search
                            </button>
                        </div>}

                        <div class='table-responsive'>
                            <table class={`${style.table} table table-striped table-sm table-borderless`}>
                                <thead>
                                    {maillogStore.sort !== maillogStore.defaultSort && <tr>
                                        <th colspan='8'>
                                            <span class={`${style.pointerCursor} mr-2 badge badge-pill badge-secondary`} onClick={() => maillogStore.resetSort()}>
                                                <i class='fas fa-times-circle' /> Reset sort
                                            </span>
                                        </th>
                                    </tr>}
                                    <tr>
                                        <th style='width: 5%' class='text-right'>Id#</th>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => maillogStore.toggleSort('createdDate', '')}>
                                                Date {util.getSortIcon('createdDate', maillogStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%'>
                                            From
                                        </th>
                                        <th style='width: 20%'>
                                            To
                                        </th>
                                        <th style='width: 35%'>
                                            <span class={style.pointerCursor} onClick={() => maillogStore.toggleSort('subject', '')}>
                                                Subject {util.getSortIcon('subject', maillogStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>Attachments</th>
                                        <th style='width: 10%'>RelayService</th>
                                        <th style='width: 5%'>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {maillogs && maillogs.map(maillog => (
                                        <tr class={`${style.tableline}`}>
                                            <td class='text-right'>
                                                {maillog.id}
                                            </td>
                                            <td class='text-right'>
                                                {util.ffeDateTime(maillog.createdDate)}
                                            </td>
                                            <td>
                                                {maillog.from}
                                            </td>
                                            <td class='font-weight-light'>
                                                {maillog.to.map(r => <span class={`badge badge-pill badge-primary mr-2`}>
                                                    {r}
                                                </span>)}
                                                {maillog.cc.map(r => <span class={`badge badge-pill badge-info mr-2`}>
                                                    {r}
                                                </span>)}
                                                {maillog.bcc.map(r => <span class={`badge badge-pill badge-secondary mr-2`}>
                                                    {r}
                                                </span>)}
                                            </td>
                                            <td>
                                                <a href={`/maillogs/${maillog.id}/Basics`}>{maillog.subject}</a>
                                            </td>
                                            <td>
                                                <small><code>{JSON.stringify(maillog.attachments)}</code></small>
                                            </td>
                                            <td>
                                                {maillog.relayService}
                                            </td>
                                            <td>
                                                {maillog.response && <span class={`badge badge-pill badge-${maillog.response[0].statusCode < 400 ? 'success' : 'danger'}`}>
                                                    {maillog.response[0].statusCode}
                                                </span>}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
                {loading && <div class='row'>
                    <div class='col-12 text-center'>
                        <div class='spinner-border text-success' role='status'>
                            <span class='sr-only'>Loading...</span>
                        </div>
                    </div>
                </div>}
                <div class='text-center mt-4 mb-2'>
                    <small class='text-muted'>
                        <i class='fas fa-ellipsis-h' />
                    </small>
                </div>
            </div>
        );
    }
}

export default MaillogList;




// WEBPACK FOOTER //
// ./components/maillogs/list.js